<div *ngIf="!isLoading">
        <div style="margin-bottom: 5px;">
        <img src="../../assets/img/UMA-DNC-header.jpg" alt="Banner"
            style="width: 100%; display: block; margin: 0; padding: 0;">
    </div>
    <div class="top-bar">
        <div class="top-bar-item" id="call-status">
            <gux-icon size="large" icon-name="toolbar-phone-active-3" decorative="true"></gux-icon>
            Call Status: {{callStatus}}
        </div>

        <div class="top-bar-item" id="call-type">
            Call Type: {{callType}}
        </div>
    </div>
    <hr>

    <app-student-info-block [studentData]="studentData" 
            [showStudentId]=false></app-student-info-block>

    <gux-form-field-textarea label-position="above" style="margin-top: 20px;">
        <textarea slot="input" name="textarea" class="dnc-message-box" id="comments" [(ngModel)]="comments"></textarea>
        <label slot="label" for="comments">Comments</label>
    </gux-form-field-textarea>

    <div class="button-container">
        <gux-button accent="{{buttonType}}" id="submit-dnc" class="call-button" (click)="submitDNC()" (keypress)="submitDNC()" [disabled]="comments === ''">
            <span>Submit DNC</span>
        </gux-button>

        <gux-button accent="danger" id="cancel-dnc" class="call-button" (click)="cancel()" (keypress)="cancel()">
            <span>Cancel</span>
        </gux-button>
    </div>
</div>